import React from "react";
export default function QGeneral(props) {
    return (<div className="col-12 form-group"></div>);
}
